import { createFileRoute } from '@tanstack/react-router';
import { UnifiedFormBuilderPage } from '@/components/forms-engine/UnifiedFormBuilderPage';

interface EditAppointmentFormSearch {
  /**
   * The "couldn't become a lead" admin notification deep-links here
   * (Task 11) so a failed intake conversion lands directly on the builder's
   * Activity tab instead of the Builder tab.
   */
  tab?: 'builder' | 'activity';
}

export const Route = createFileRoute('/_dashboard/dashboard/settings/appointment-forms/$id/edit')({
  validateSearch: (search: Record<string, unknown>): EditAppointmentFormSearch => ({
    tab: search.tab === 'activity' ? 'activity' : undefined,
  }),
  component: EditAppointmentFormPage,
});

function EditAppointmentFormPage() {
  const { id } = Route.useParams();
  const { tab } = Route.useSearch();
  return <UnifiedFormBuilderPage mode="edit" templateId={id} initialTab={tab} />;
}
